export default function toExtraLink(extraLink: string) {
  if (extraLink.startsWith("https://")) return extraLink;
  return `https://${extraLink}`;
}
